import React, { useState } from 'react';
import styled from 'react-emotion';
import { theme } from '../Theme';

const AccordionWrapper = styled('div')`
  max-width: 700px;
  margin: auto;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  margin-top: -1px;
`;
const AccordionTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  cursor: pointer;
  span {
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 5px 0;
    ${theme.below.lg} {
      font-size: 14px;
    }
  }
`;
const AccordionContent = styled('div')`
  overflow: hidden;
  transition: 0.5s ease;
  display: none;
  &.active {
    display: block;
  }
`;
const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
  margin-left: 15px;
`;
const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);
const FAQ = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <AccordionWrapper>
      <AccordionTitle onClick={() => setIsOpen(!isOpen)}>
        <span>{title}</span>
        <AccordionIndicator isOpen={isOpen} />
      </AccordionTitle>
      <AccordionContent className={isOpen ? 'active' : 'inactive'}>
        {children}
      </AccordionContent>
    </AccordionWrapper>
  );
};

export default FAQ;
